import { configureStore } from '@reduxjs/toolkit';
import userSlice from './userSlice'; // Crea este archivo en el siguiente paso

const store = configureStore({
	reducer: {
		user: userSlice,
	},
});

export default store;